import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogTitle } from "@material-ui/core/";
import TextField from "@material-ui/core/TextField";
import DialogContent from "@material-ui/core/DialogContent";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Close from '@material-ui/icons/Close';

// design
const useStyles = makeStyles((theme) => ({
    input: {
        backgroundColor: "#FAFAFA",
    }

}));
// set action item  timeout ms configuration 
const Timeout = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const [flowTimeOut, setFlowTimeOut] = useState(5000);

    // close modal
    const handleClose = () => {
        props.setOpen(false);
    };

    return (
        <Dialog
            id="autom-addNew-modal"
            data-test="autom-add-new"
            open={true}
            onClose={handleClose}
        >
            <DialogTitle
                id="alert-dialog-title"
            >
                <div id="about-title">
                    <b>{t("CONTENT.AUTOMS-LIST.TIMEOUT")}</b>
                    <Button data-test="cancelautom-button" onClick={handleClose}>
                        <Close />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent>
                <div style={{ textAlign: "left" }}>
                    <Grid container >
                        <Grid item xs={12}>
                            <span className="dialog-text">{t("CONTENT.AUTOMS-LIST.TIMEOUT")}(ms)</span>
                            <TextField
                                id="filled-size-small"
                                className={classes.input}
                                value={flowTimeOut}
                                onChange={(e) => setFlowTimeOut(e.target.value)}
                                variant="outlined"
                                size="small"
                                type="number"
                                fullWidth
                                inputProps={{ style: { fontSize: 12 } }}
                            />
                            {flowTimeOut < 2000 ? <small>Please enter over 2000 ms</small> : null}
                        </Grid>
                        <Button
                            data-test="submitdialog-button"
                            variant="outlined"
                            style={{ backgroundColor: "#46474E", borderRadius: "2px", color: "#fff", width: "100%", border: "none", marginTop: 20, marginBottom: 20 }}>
                            {t("CONTENT.AUTOMS-LIST.ADD")}
                        </Button>
                    </Grid>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default Timeout;
